import React from 'react';
const DiamondPurpleSvg = ({ id }) => {
    const linear1 = `linear_DP_1_${id}`;
    const linear2 = `linear_DP_2_${id}`;
    const linear3 = `linear_DP_3_${id}`;
    const linear4 = `linear_DP_4_${id}`;
    const linear5 = `linear_DP_5_${id}`;
    const linear6 = `linear_DP_6_${id}`;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M22 8H17L12 23L22 8Z", fill: `url(#${linear1})` }),
        React.createElement("path", { d: "M2 8H7L8 3L2 8Z", fill: `url(#${linear2})` }),
        React.createElement("path", { d: "M22 8H17L16 3L22 8Z", fill: `url(#${linear3})` }),
        React.createElement("path", { d: "M2 8H7L12 23L2 8Z", fill: `url(#${linear4})` }),
        React.createElement("path", { d: "M7 8H17L12 23L7 8Z", fill: `url(#${linear5})` }),
        React.createElement("path", { d: "M8 3H16L17 8H7L8 3Z", fill: `url(#${linear6})` }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: linear1, x1: "14.7778", y1: "8.68182", x2: "24.7803", y2: "19.3962", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#8D49D2" }),
                React.createElement("stop", { offset: "1", stopColor: "#E28D97" })),
            React.createElement("linearGradient", { id: linear2, x1: "8", y1: "8", x2: "6.12734", y2: "5.00375", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E99292" }),
                React.createElement("stop", { offset: "1", stopColor: "#8D49D1" })),
            React.createElement("linearGradient", { id: linear3, x1: "16", y1: "6.40909", x2: "21.5726", y2: "5.56267", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#C8A4EC" }),
                React.createElement("stop", { offset: "1", stopColor: "#E18C98" })),
            React.createElement("linearGradient", { id: linear4, x1: "5.88889", y1: "14.875", x2: "14.6433", y2: "11.6391", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#8D49D2" }),
                React.createElement("stop", { offset: "1", stopColor: "#DE8A9A" })),
            React.createElement("linearGradient", { id: linear5, x1: "10.8889", y1: "14.875", x2: "19.6433", y2: "11.6391", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#8D49D2" }),
                React.createElement("stop", { offset: "1", stopColor: "#DE8A9A" })),
            React.createElement("linearGradient", { id: linear6, x1: "8", y1: "7.5", x2: "9.26103", y2: "2.05508", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E99292" }),
                React.createElement("stop", { offset: "1", stopColor: "#8D49D1" })))));
};
export { DiamondPurpleSvg };
//# sourceMappingURL=DiamondPurpleSvg.js.map